import { RTCClient } from 'utils/webrtc';
import { AppThunk } from 'store/store';

/**
 * Must remain synchronous: `retryBlockedMedia()` calls `play()` on every
 * blocked audio and video element, and the browser's user-activation token
 * only survives across them if they execute in the same task as the click.
 * Do NOT add `await`, `setTimeout`, microtask hops, or other work that would
 * yield control.
 */
export const enableMediaPlaybackClicked = (): AppThunk<void> => () => {
  RTCClient.receivingFeed.retryBlockedMedia();
};
